// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBXnPDSiHy5SX-bPXKIUPbvLl2_ZRVxw3c',
    authDomain: 'collado-aa532.firebaseapp.com',
    databaseURL: 'https://collado-aa532.firebaseio.com',
    projectId: 'collado-aa532',
    storageBucket: 'collado-aa532.appspot.com',
    messagingSenderId: '947204691283',
    appId: '1:947204691283:web:f732b41b09a9b0f9f43da6',
    measurementId: 'G-90YMM7ZQHN'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
